import React__default from 'react';
import cn from 'classnames';
import { useTranslate } from '@awardit/react-use-translate';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styles from 'ui-components/AddToCart.scss';
import { DropdownSelect, DropdownSelectCustom } from '../ProductOptions/dropdown.js';
import { Input } from '../Input/index.js';
import { TextArea } from '../TextArea/index.js';

var ConfigurableConfigurations = function ConfigurableConfigurations(_ref) {
  var selected = _ref.selected,
    select = _ref.select,
    configAttributes = _ref.configAttributes,
    _ref$templates = _ref.templates,
    templates = _ref$templates === void 0 ? {} : _ref$templates;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Object.keys(configAttributes).map(function (attributeKey) {
    var attribute = configAttributes[attributeKey];
    var Component = templates && typeof templates[attributeKey] !== "undefined" ? templates[attributeKey] : DropdownSelect;

    // Handle different config types: for example Dropdown
    return /*#__PURE__*/React__default.createElement("div", {
      key: attributeKey,
      className: cn(styles.optionRow, styles[attribute.name])
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: styles.optionLabel
    }, attribute.label), /*#__PURE__*/React__default.createElement(Component, {
      key: attributeKey,
      attribute: attribute,
      items: attribute.items.map(function (x) {
        return {
          key: x.buyRequest || "",
          buyRequest: x.buyRequest,
          label: x.label,
          product: x.product,
          price: x.price
        };
      }),
      value: selected[attributeKey],
      onChange: function onChange(v) {
        var selectedProduct = attribute.items.find(function (a) {
          return a.buyRequest === v;
        });
        if (selectedProduct) {
          var _select;
          select((_select = {}, _select[attribute.name] = v, _select));
        }
      }
    }));
  }));
};
var BundleConfigurations = function BundleConfigurations(_ref2) {
  var selected = _ref2.selected,
    select = _ref2.select,
    bundleAttributes = _ref2.bundleAttributes,
    _ref2$templates = _ref2.templates,
    templates = _ref2$templates === void 0 ? {} : _ref2$templates;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, bundleAttributes.map(function (option) {
    var Component = templates && typeof templates[option.optionId] !== "undefined" ? templates[option.optionId] : DropdownSelect;
    return /*#__PURE__*/React__default.createElement("div", {
      key: "option" + option.optionId,
      className: cn(styles.optionRow, styles[option.optionId])
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: styles.optionLabel
    }, option.title), /*#__PURE__*/React__default.createElement(Component, {
      key: option.optionId,
      attribute: {
        label: option.title,
        name: option.optionId
      },
      items: option.selections.map(function (x) {
        return {
          buyRequest: x.selectionId,
          label: x.product.name,
          product: x.product
        };
      }),
      value: selected[option.optionId],
      onChange: function onChange(o) {
        var _select2;
        select((_select2 = {}, _select2[option.optionId] = o, _select2));
      }
    }));
  }));
};
var CustomOptionsChoiceConfigurations = function CustomOptionsChoiceConfigurations(_ref3) {
  var selected = _ref3.selected,
    setSelected = _ref3.setSelected,
    option = _ref3.option;
  var attribute = _extends({}, option, {
    name: option.title,
    label: option.title
  });
  if (attribute.values === null || attribute.values.length === 0) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    key: attribute.title,
    className: cn(styles.optionRow, styles[attribute.title])
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: styles.optionLabel
  }, attribute.title), /*#__PURE__*/React__default.createElement(DropdownSelectCustom, {
    attribute: attribute,
    items: attribute.values.map(function (x) {
      return {
        key: x.id || "",
        buyRequest: x.buyRequest,
        label: x.title,
        id: x.id,
        product: null
      };
    }),
    value: selected[attribute.name],
    onChange: function onChange(v) {
      if (v) {
        setSelected(function (prev) {
          var _extends2;
          return _extends({}, prev, (_extends2 = {}, _extends2[attribute.name] = v, _extends2));
        });
      }
    }
  }));
};
var CustomOptionsInputConfigurations = function CustomOptionsInputConfigurations(_ref4) {
  var option = _ref4.option,
    textValues = _ref4.textValues,
    setTextValues = _ref4.setTextValues,
    fieldVariant = _ref4.fieldVariant,
    errorValues = _ref4.errorValues,
    setErrorValues = _ref4.setErrorValues;
  var required = option.required,
    title = option.title,
    id = option.id;
  var t = useTranslate();
  var textInputErrorString = t("ERROR.REQUIRED_TEXT_INPUT");
  if (textValues[id] === undefined || textValues[id] === null) {
    setTextValues(function (prev) {
      var _extends3;
      return _extends({}, prev, (_extends3 = {}, _extends3[id] = "", _extends3));
    });
  }
  switch (option.type) {
    case "field":
      return /*#__PURE__*/React__default.createElement("div", {
        className: cn(styles.optionRow, styles.input)
      }, /*#__PURE__*/React__default.createElement(Input, {
        type: "text",
        label: title,
        required: required,
        variant: fieldVariant || "",
        value: textValues[id] || "",
        errors: errorValues[id] !== null && errorValues[id] !== undefined ? [errorValues[id]] : [],
        onInvalid: function onInvalid(e) {
          e.preventDefault();
          setErrorValues(function (prev) {
            var _extends4;
            return _extends({}, prev, (_extends4 = {}, _extends4[id] = textInputErrorString, _extends4));
          });
        },
        onChange: function onChange(e) {
          e.persist();
          setErrorValues(function (prev) {
            var _extends5;
            return _extends({}, prev, (_extends5 = {}, _extends5[id] = null, _extends5));
          });
          setTextValues(function (prev) {
            var _extends6;
            return _extends({}, prev, (_extends6 = {}, _extends6[id] = e.target.value, _extends6));
          });
        }
      }));
    case "area":
      return /*#__PURE__*/React__default.createElement("div", {
        className: cn(styles.optionRow)
      }, /*#__PURE__*/React__default.createElement(TextArea, {
        label: title,
        required: required,
        value: textValues[id] || "",
        errors: errorValues[id] !== null && errorValues[id] !== undefined ? [errorValues[id]] : [],
        onInvalid: function onInvalid(e) {
          e.preventDefault();
          setErrorValues(function (prev) {
            var _extends7;
            return _extends({}, prev, (_extends7 = {}, _extends7[id] = textInputErrorString, _extends7));
          });
        },
        onChange: function onChange(e) {
          e.persist();
          setErrorValues(function (prev) {
            var _extends8;
            return _extends({}, prev, (_extends8 = {}, _extends8[id] = null, _extends8));
          });
          setTextValues(function (prev) {
            var _extends9;
            return _extends({}, prev, (_extends9 = {}, _extends9[id] = e.target.value, _extends9));
          });
        }
      }));
    default:
      return null;
  }
};

export { BundleConfigurations, ConfigurableConfigurations, CustomOptionsChoiceConfigurations, CustomOptionsInputConfigurations };
//# sourceMappingURL=configurations.js.map
